<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :backButtonEnable="false"
  >
    <template #headerContent>
      <GcHeaderContentStatic
        title="Purchase Orders"
        :screenName="'Purchase Orders - Goods In Interrogation'"
      />
    </template>

    <div class="css-v2 grid-report">
      <gc-data-grid-report
        v-if="report.dataSourceConfig"
        :exportFileName="report.exportFileName"
        :dataSourceConfig="reportDataSourceConfig"
        :columns="columns"
        :gridOptions="gridOptions"
        :persistenceKey="persistenceKey"
        :heightPadding="20"
        :gridToolbar="gridToolbar"
      >
      </gc-data-grid-report>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import GcDataGridReport from "@/components/gc-data-grid-report";
import { ScreenLayoutService } from "@/_services/api/reports/screen-layout.service";
import { CommonStorage } from "../../../_services/storage";
import {
  PurchaseListTabs,
  GetIndexByTabName,
} from "@/_models/tabdata/purchasing/purchase-list-tabs";

export default {
  props: {
    /**
     * contains report configurations
     */
    reportConfig: {
      type: Object,
      default: undefined,
    },
  },
  mixins: [RouteMixin],
  components: {
    GcDataGridReport,
  },

  data() {
    return {
      persistenceKey: "report-grid-purchase-price-variance",
      report: {
        title: "",
        exportFileName: "",
        featureCode: "",
        dataSourceConfig: null,
        columns: [],
      },
      gridOptions: {
        // noDataMessage: {
        //   addNew: {
        //     class: "no-data",
        //     title: "No Transactions",
        //     message:
        //       "Currently there are no transactions for customers. Give them a call and sell them something today!",
        //   },
        // },
      },
      gridToolbar: {
        search: false,
        columnChooser: true,
        export: true,
        openFilter: true,
        filterOnEnter: true,
      },
      tabs: PurchaseListTabs(),
      selectedIndex: GetIndexByTabName("Goods In Interrogation"),
    };
  },
  computed: {
    reportDataSourceConfig() {
      var config = this.report.dataSourceConfig;
      // config.filter = [["CustomerCode", "=", this.model.Code]];
      return config;
    },

    columns() {
      var cols = this.report.columns;

      return cols;
    },
  },

  async created() {
    CommonStorage.clear("go_back_route");
    let response = await ScreenLayoutService.getByRoute(
      "report-grid-purchase-price-variance",
    );
    if (response.data.value) {
      const report = JSON.parse(response.data.value[0].Definition);

      var url = window.location.href;
      if (url.indexOf("?") != -1) {
        if (Object.keys(this.baseView.query).length != 0) {
          CommonStorage.clear("filter-panel-" + this.persistenceKey);
          CommonStorage.clear(this.persistenceKey);
          report.columns.forEach((element) => {
            if (element.filterDefaultValue != undefined)
              element.filterDefaultValue = undefined;

            if (this.baseView.query[element.screenField] != undefined) {
              element.filterDefaultValue = JSON.parse(
                this.baseView.query[element.screenField],
              );
            }
          });
        }
      }
      this.report = report;
    }
  },
  methods: {},
};
</script>
